const deleteGaps = value => {
  if (typeof value === 'string') {
    return value.replace(/\s/g, '');
  }
  return '';
};

export default deleteGaps;
